import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a3c28362"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-challenge" }
const _hoisted_2 = { class: "box-challenge" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "footer-btn-group" }
const _hoisted_7 = ["disabled"]
const _hoisted_8 = { class: "footer-btn-group" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tip" }, " *아래 사항을 모두 확인하고 순서대로 클릭해 주세요 ", -1))
const _hoisted_10 = { class: "box-options" }
const _hoisted_11 = { class: "footer-btn-group" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, " 몇 개의 제로 웨이스트 박스를 수거 신청하나요? "),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 박스 수량만큼 택배 송장이 필요하니"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 정확한 수량을 선택해 주세요 ")
  ])
], -1))
const _hoisted_15 = { class: "box-input" }
const _hoisted_16 = ["disabled"]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "29",
  viewBox: "0 0 30 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "1",
    y: "0.5",
    width: "28",
    height: "28",
    rx: "14",
    stroke: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.4084 13.418H18.6604V15.126H11.4084V13.418Z",
    fill: "#303030"
  })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "value" }
const _hoisted_20 = ["disabled"]
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "30",
  height: "29",
  viewBox: "0 0 30 29",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("rect", {
    x: "1",
    y: "0.5",
    width: "28",
    height: "28",
    rx: "14",
    stroke: "black"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M11.4084 13.418H13.9984V10.982H16.0704V13.418H18.6604V15.126H16.0704V17.8H13.9984V15.126H11.4084V13.418Z",
    fill: "#303030"
  })
], -1))
const _hoisted_22 = [
  _hoisted_21
]
const _hoisted_23 = ["src"]
const _hoisted_24 = ["src"]
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "box-desc" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 3~4일 이내에"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 한진택배 기사님이 방문하여 수거해 갈 거예요. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "desc" }, [
    /*#__PURE__*/_createTextVNode(" 리워드는 보내 주신 제로 웨이스트 박스"),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode(" 검수 후 순차적으로 발송돼요. ")
  ])
], -1))
const _hoisted_26 = ["src"]
const _hoisted_27 = { class: "footer-btn-group" }
const _hoisted_28 = { class: "footer-btn-group" }
const _hoisted_29 = { class: "footer-btn-group" }
const _hoisted_30 = { class: "footer-btn-group" }

import Popup from './popup.vue';
import PopupError from './popup-error.vue';
import { type Ref, type DeepReadonly, type ComputedRef, reactive, nextTick, inject, computed, ref } from 'vue';
import { IProgram } from '@/types/program';
import { useRouter } from 'vue-router';
import Options from './options.vue';
import { request } from '@/utils';
import _  from 'lodash';

export interface CollectExpose {
  start(): void;
}


  const __default__ = {
    inheritAttrs: false
  };

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props, { expose }) {

const images = inject<ComputedRef<Record<string, string>>>('images')!;

const program = inject<DeepReadonly<Ref<IProgram>>>('program');
const refreshPageData = inject<Function>('refreshPageData') || _.noop;

const errMsg = ref('');
const popupVisible = reactive({
  step1: false,
  step2: false,
  step3: false,
  success: false,
  requestWaitingLists: false,
  operationSuccess: false,
  step1Error: false,
  error: false,
});

function hidePopup(key?: keyof typeof popupVisible) {
  if (key) {
    popupVisible[key] = false;
  } else {
    _.forEach(popupVisible, (val, key) => {
      if (val) {
        popupVisible[key] = false;
      }
    });
  }
}

async function showPopup(key: keyof typeof popupVisible) {
  hidePopup();
  await nextTick();
  popupVisible[key] = true;
}

const collectionChallenges = [2, 4];

const getDefaultForm = () => {
  return {
    request_times: 1,
    collection_challenge: undefined,
  };
};
const form = reactive<{
  collection_challenge?: typeof collectionChallenges[number]
  request_times: number;
}>(getDefaultForm());

function onCollectionSelect(challenge: typeof collectionChallenges[number]) {
  form.collection_challenge = challenge;
}

function onStep1Submit() {
  if (String(program?.value.collection_challenge) === String(form.collection_challenge)) {
    showPopup('step2');
  } else {
    showPopup('step1Error');
  }
}

const router = useRouter();
function navToProfileEdit() {
  hidePopup();
  router.push({ name: 'mine.memberProfile' });
}

const step2Options = [
  // 如果您不遵循正确的分离方法或发送透明塑料饮料瓶以外的物品，您将不会获得奖励。
  `올바른 <strong>분리배출 방법을 지키지 않거나 <br>
    투명 음료 페트병이 아닌 품목</strong>을 보내면 <br>
  리워드를 받을 수 없어요.`,
  // 如果零废物箱没有填满标记线，将很难提供奖励。
  `<strong>제로 웨이스트 박스가 표시선까지 채워</strong>지지 <br>
  않으면 리워드 제공이 어려워요.`,
  // 送货司机将前往您登记的地址，因此请输入正确的地址。
  `등록된 주소지로 택배 기사님이 방문하므로 <br>
  <strong>정확한 주소를 입력</strong>해 주세요`,
];

const getDefaultStep2OptionSelected = () => [];
const step2OptionSelected = ref(getDefaultStep2OptionSelected());
const step2OptionAllChecked = computed(() => step2OptionSelected.value.length === step2Options.length);

function onRequestTimesAdd() {
  form.request_times += 1;
}

function onRequestTimesMinus() {
  form.request_times -= 1;
}

const requestWaitingListsMessage = ref('');
async function onStep3Submit() {
  try {
    await request.post('user_requests', {
      target_id: program?.value.id,
      target_type: 'Program',
      type: 'CollectionRequest',
      request_times: form.request_times,
    }, {
      loading: { silent: true }
    });
    await refreshPageData();
    showPopup('success');
  } catch (e) {
    const errorMsg = _.get(e, 'message');
    const code = _.get(e, 'code');
    const status = _.get(e, 'status');
    // 项目人次达到上限，需要显示错误信息并提示是否订阅 waiting list
    if (status !== 401 && String(code) === '40008') {
      requestWaitingListsMessage.value = errorMsg;
      showPopup('requestWaitingLists');
      return;
    }
    // request.ts已经处理过这个code了
    if (String(code) !== '40305') {
      errMsg.value = errorMsg;
      showPopup('error');
    }

     else {
      errMsg.value = errorMsg;
      showPopup('error');
    }
    // throw e;
  }
}

async function subscribeWaitingList() {
  await request.post('request_waiting_lists', {
    kind: 'collection',
    program_id: program?.value.id
  });
  showPopup('operationSuccess');
}

function start() {
  Object.assign(form, getDefaultForm());
  step2OptionSelected.value = getDefaultStep2OptionSelected();
  showPopup('step1');
}

expose<CollectExpose>({
  start,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step1,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(popupVisible).step1) = $event)),
      class: "collect-modal step-1",
      title: "원더플 피플!<br>참여 중인 챌린지 유형을 선택해 주세요"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            disabled: !_unref(form).collection_challenge,
            onClick: onStep1Submit
          }, " 확인 ", 8, _hoisted_7)
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              class: "bottle-1-line",
              src: _unref(images)['bottle-135deg-1-line']
            }, null, 8, _hoisted_3),
            _createElementVNode("img", {
              class: "bottle-45deg",
              src: _unref(images)['bottle-45deg']
            }, null, 8, _hoisted_4),
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(collectionChallenges, (item) => {
              return _createElementVNode("div", {
                key: item,
                class: _normalizeClass(["item", { active: item === _unref(form).collection_challenge }]),
                onClick: ($event: any) => (onCollectionSelect(item))
              }, _toDisplayString(item) + "박스 ", 11, _hoisted_5)
            }), 64))
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).step1Error,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(popupVisible).step1Error) = $event)),
      title: "참여 중인 챌린지 유형을 다시 확인해주세요.",
      class: "step-1-error"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (showPopup('step1')))
          }, " 확인 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step2,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(popupVisible).step2) = $event)),
      class: "collect-modal step-2",
      title: "수거 신청 전 한 번 더 확인!"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: navToProfileEdit
          }, " 주소지 변경 "),
          _createElementVNode("button", {
            class: "footer-btn primary",
            disabled: !_unref(step2OptionAllChecked),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (showPopup('step3')))
          }, " 확인했어요 ", 8, _hoisted_12)
        ])
      ]),
      default: _withCtx(() => [
        _hoisted_9,
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Options, {
            modelValue: step2OptionSelected.value,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((step2OptionSelected).value = $event)),
            options: step2Options
          }, null, 8, ["modelValue"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).step3,
      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(popupVisible).step3) = $event)),
      class: "collect-modal step-3",
      title: "수거 박스 수량"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("img", {
          class: "bottle-45deg",
          src: _unref(images)['bottle-45deg']
        }, null, 8, _hoisted_23),
        _createElementVNode("div", { class: "footer-btn-group" }, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: onStep3Submit
          }, " 수거 신청 ")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "bottle-1-line",
          src: _unref(images)['bottle-135deg-1-line']
        }, null, 8, _hoisted_13),
        _hoisted_14,
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("button", {
            class: "button btn-minus",
            disabled: _unref(form).request_times <= 1,
            onClick: onRequestTimesMinus
          }, _hoisted_18, 8, _hoisted_16),
          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(form).request_times), 1),
          _createElementVNode("button", {
            class: "button btn-add",
            disabled: _unref(form).request_times >= (_unref(program)?.remaining_collection_times || 0),
            onClick: onRequestTimesAdd
          }, _hoisted_22, 8, _hoisted_20)
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(Popup, {
      modelValue: _unref(popupVisible).success,
      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(popupVisible).success) = $event)),
      title: "수거 신청 완료",
      class: "collect-modal step-success"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("img", {
          class: "bottle-45deg",
          src: _unref(images)['bottle-45deg']
        }, null, 8, _hoisted_26),
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: _cache[7] || (_cache[7] = ($event: any) => (hidePopup()))
          }, " 완료 ")
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("img", {
          class: "bottle-1-line",
          src: _unref(images)['bottle-135deg-1-line']
        }, null, 8, _hoisted_24),
        _hoisted_25
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).error,
      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(popupVisible).error) = $event)),
      title: errMsg.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[9] || (_cache[9] = ($event: any) => (_unref(popupVisible).error = false))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).requestWaitingLists,
      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(popupVisible).requestWaitingLists) = $event)),
      title: requestWaitingListsMessage.value
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_29, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(popupVisible).requestWaitingLists = false))
          }, " 닫기 "),
          _createElementVNode("button", {
            class: "footer-btn primary",
            onClick: subscribeWaitingList
          }, " 신청할게요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(PopupError, {
      modelValue: _unref(popupVisible).operationSuccess,
      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(popupVisible).operationSuccess) = $event)),
      title: "정보가 성공적으로 입력 되었습니다."
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("button", {
            class: "footer-btn",
            onClick: _cache[13] || (_cache[13] = ($event: any) => (_unref(popupVisible).operationSuccess = false))
          }, " 확인했어요 ")
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})